import { Box, Grid2, styled } from '@mui/material';
import { useImageContext } from '../../imageContext';
import { ImageFolder } from '../ImageFolder';
import { ImageFile } from '../ImageFile';
import InputField from '../InputField';
import InputRowContainer from '../InputRowContainer';

/*
const InputGrid = styled(Grid2)({
  fontWeight: 'bold',
  backgroundColor: '#D3D3D3',
  weigth: '100%',
});

const ContainerGrid = styled(Grid2)({
  paddingTop: '5px',
});
*/
const FileContainerTopGrid = styled(Grid2)(({ theme }) => ({
  height: '150px',
  [theme.breakpoints.down('sm')]: {
    height: '200px',
  },
}));

const FileContainerGrid = styled(Grid2)(({ theme }) => ({
  width: '700px',
  height: '150px',
  border: '1px solid lightgray',
  borderRadius: '3px',
  overflowX: 'auto',
  overflowY: 'auto',
  background: '#fff',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    minWidth: 0,
    height: '200px',
    maxHeight: '40vh',
    fontSize: '0.95rem',
    padding: '4px',
  },
}));

export interface ReferenceImageListProps {
  readOnly: boolean | undefined;
  selectedImages: string[];

  labelId: string;
  disabled: boolean;
  onLock: (field: string, locked: boolean) => void;
  disabledLock: boolean;
  displayedLock: boolean;
  isLocked: boolean;
}

export const ReferenceImageList = (props: ReferenceImageListProps): JSX.Element => {
  const {
    itemList,
    search,
    setSearch,
  } = useImageContext();

  const sSearchTitle = 'Search';
  const sSearchBody = 'Use search to decrease the size of the image list. <><>Search is case insensitive.';

  return (
    <>
      <Box bgcolor="#F3F6FE" borderRadius={4} marginLeft={'8px'} sx={{
        maxWidth: '100vw',
        overflowX: 'auto',
        padding: { xs: '4px', sm: '8px' },
      }}>
        <Box>
          <InputRowContainer>
            <InputField
              labelText={'Search'}
              labelId={'references'}
              mandatory={false}
              helpTextTitle={sSearchTitle}
              helpTextBody={sSearchBody}
              value={search || ''}
              onChange={(value) => setSearch(value)}
              onBlur={() => {
                // Intentionally left empty
                }
              }
              fullWidth={true}
              error={false}
              helperText={''}
              rows={1}
              disabled={false}
              onLock={props.onLock}
              disabledLock={props.disabledLock}
              displayedLock={props.displayedLock}
              isLocked={props.isLocked}
            />
          </InputRowContainer>
          <InputRowContainer>
        <FileContainerTopGrid container size={12} >
          <FileContainerGrid size={12} sx={{bgcolor:'#FFFFFF'}}>
            {props.selectedImages.map(selectedImage => {
                return <ImageFile
                  item={selectedImage}
                  readOnly={props.readOnly}
                  highlight={true}/>;
            })

            }
            {itemList.map((item) => {
              const match =
                search === '' ||
                item.toLowerCase().indexOf(search.toLowerCase()) >= 0;

              if (match && item.endsWith('/')) {
                return <ImageFolder item={item} readOnly={props.readOnly} />;
              } else if (match && !item.endsWith('/') && !props.selectedImages.includes(item)) {
                return <ImageFile
                  item={item}
                  readOnly={props.readOnly}
                  highlight={false}
                  />;
              }
            })}
          </FileContainerGrid>
        </FileContainerTopGrid>
        </InputRowContainer>
    </Box></Box>
    </>
  );
};
